import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'lib-pagination',
    standalone: true,
    imports: [
        NgForOf,
        NgIf,
        NgbDropdown,
        NgbDropdownToggle,
        NgbDropdownMenu
    ],
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnInit, OnChanges {
    @Input() totalItems!: number;
    @Input() currentPage = 1;
    @Input() itemsPerPage = 10;
    @Input() firstPageIdentifier = 'pagination-first';
    @Input() previousPageIdentifier = 'pagination-previous';
    @Input() currentPageIdentifier = 'pagination-pagenumber';
    @Input() nextPageIdentifier = 'pagination-next';
    @Input() lastPageIdentifier = 'pagination-last';
    @Input() viewByIdentifier = 'pagination-viewby';
    @Output() changeCurrentPage: EventEmitter<number> = new EventEmitter<number>();
    @Output() selectItemsPerPage: EventEmitter<number> = new EventEmitter<number>();

    pages: number[] = [];
    itemsPerPageOptions = [10, 25, 50, 100];

    get totalPages(): number {
        return Math.ceil(this.totalItems / this.itemsPerPage);
    }

    ngOnInit(): void {
        this.reloadPages();
    }

    reloadPages(): void {
        this.pages = this.getPages(this.currentPage, this.totalPages);
    }

    onSelectItemsPerPage(itemsPerPage: number): void {
        this.itemsPerPage = itemsPerPage;
        this.selectItemsPerPage.emit(this.itemsPerPage);
        this.onChangeCurrentPage(1);
    }

    onGoTo(page: number): void {
        this.onChangeCurrentPage(page);
    }

    onNext(): void {
        this.onChangeCurrentPage(this.currentPage + 1);
    }

    onPrevious(): void {
        this.onChangeCurrentPage(this.currentPage - 1);
    }

    onFirst(): void {
        this.onChangeCurrentPage(1);
    }

    onLast(): void {
        this.onChangeCurrentPage(this.totalPages);
    }

    onChangeCurrentPage(page: number): void {
        this.currentPage = page;
        this.reloadPages();
        this.changeCurrentPage.emit(this.currentPage);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            (changes[ 'currentPage' ]?.currentValue) ||
            (changes[ 'totalItems' ]?.currentValue)
        ) {
            this.reloadPages();
        }
    }

    private getPages(current: number, total: number): number[] {
        if (total <= 7) {
            return [...Array(total).keys()].map(x => ++x);
        }

        if (current > 5) {
            if (current >= total - 4) {
                return [1, -1, total - 4, total - 3, total - 2, total - 1, total];
            } else {
                return [1, -1, current - 1, current, current + 1, -1, total];
            }
        }

        return [1, 2, 3, 4, 5, -1, total];
    }
}
